import PerfessionSpecField from './PerfessionSpecField'
import GridDynamicCellEditor from './GridDynamicCellEditor.vue'
import ProfessionTabWidget from './ProfessionTabWidget.vue'
import ComputedWidget from './ComputedWidget.vue'
export default {
    install: function(app){
        app.component('perfession-spec-field',PerfessionSpecField)
        app.component('GridDynamicCellEditor',GridDynamicCellEditor)
        app.component('ProfessionTabWidget',ProfessionTabWidget)
        app.component('ComputedWidget',ComputedWidget)
    }
}